import { Directive } from '@angular/core';
import {FormControl, NG_VALIDATORS} from '@angular/forms';
import {checkIfASCII} from '../util/CommonFunctions';


export function asciiValidator(control: FormControl) {
  const value = control.value;
  if (value == null || value.trim() === '') {
    return null;
  }


  if (!checkIfASCII(value)) {
    return {
      invalidValue: 'Invalid, value cannot contain non-ASCII characters'
    };
  }


  return null;
}

@Directive({
    selector: '[asciiValidator][ngModel]',
    providers: [
        { provide: NG_VALIDATORS, useValue: asciiValidator, multi: true }
    ],
    standalone: false
})
export class AsciiValidatorDirective {

  constructor() { }

}
